import React, { createContext, useContext } from 'react';
import { WorkflowConfig } from './types';

const WorkflowConfigContext = createContext<WorkflowConfig | null>(null);

interface WorkflowConfigProviderProps {
  config: WorkflowConfig;
  children: React.ReactNode;
}

export const WorkflowConfigProvider: React.FC<WorkflowConfigProviderProps> = ({
  config,
  children,
}) => (
  <WorkflowConfigContext.Provider value={config}>
    {children}
  </WorkflowConfigContext.Provider>
);

export const useWorkflowConfig = (): WorkflowConfig => {
  const config = useContext(WorkflowConfigContext);
  if (!config) {
    throw new Error(
      'useWorkflowConfig must be used within a WorkflowConfigProvider',
    );
  }
  return config;
};
